// extracted by mini-css-extract-plugin
export default {"wrapper":"CusSettlementRule_wrapper__Op3As","col":"CusSettlementRule_col__MUpVM"};